import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    buttonContainer: {
      margin: '1rem 0',

      display: 'flex',
      gap: '1.2rem',

      '& button': {
        width: '100%',
        height: '3.6rem',
        margin: 0,
        padding: 0,

        gap: '1rem',
      },
    },
  }),
)
